import axios from "axios";
import { AuthInterface } from "../model/AuthInterface";

const headers = {
  'X-Requested-With': 'XMLHttpRequest',
  'Content-Type': 'application/json'
};

const getLoginUser = () => {
  return axios.get('/api/security/login-user');
};

const login = (user: AuthInterface) => {
  return axios.post('/api/login', user, { headers });
};

const logout = () => {
  return axios.get('/api/logout');
};

const saveAccessLog = () => {
  return axios.post('/api/log/access');
}

export { getLoginUser, login, logout, saveAccessLog };
